import { Component, input, output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { TranslateModule } from '@ngx-translate/core';
import { IconComponent } from '@shared/components/icon/icon.component';
import { StatusBadgeComponent } from '@shared/components/status-badge/status-badge.component';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';
import { ICampaignDetailsDeliverablesStatusOption } from '../campaign-details-deliverables.interface';

@Component({
  imports: [NgxSkeletonLoaderModule, StatusBadgeComponent, TranslateModule, MatButtonModule, IconComponent],
  selector: 'app-campaign-details-deliverables-status-filters',
  templateUrl: './campaign-details-deliverables-status-filters.component.html',
})
export class CampaignDetailsDeliverablesStatusFiltersComponent<TStatusKey> {
  public readonly loaderCount = input.required<number>();

  public readonly loading = input<boolean>(false);
  public readonly selectedStatuses = input<Set<TStatusKey>>(new Set<TStatusKey>());
  public readonly statusOptions = input<ICampaignDetailsDeliverablesStatusOption<TStatusKey>[]>([]);

  public readonly selectedStatusesChanged = output<Set<TStatusKey>>();

  public onClear(): void {
    this.selectedStatusesChanged.emit(new Set<TStatusKey>());
  }

  public onToggleStatus(statusKey: TStatusKey): void {
    const nextStatuses = new Set(this.selectedStatuses());

    if (nextStatuses.has(statusKey)) {
      nextStatuses.delete(statusKey);
    } else {
      nextStatuses.add(statusKey);
    }

    this.selectedStatusesChanged.emit(nextStatuses);
  }
}
